export const reverseDate = (date?: string | null) =>
  date ? date.split('-').reverse().join('.') : '';
